import React, { useState, useEffect, useContext } from 'react';
import Header from '../../Header/AppHeader';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import FormatEmail from '../EmailService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Axiosfetch from '../Axiosfetch';
import baseURL from '../Config';
import FailureAlert from '../Failure';
import { ThemeContext } from '../ThemeProvider';
import WelcomeIcon from '../../../Images/MFILogo.png';

const EmailSettingsData = {
    SMTP: "",
    PORT: 0,
    Login: "",
    Password: "",
    From: "",
    Subject: "",
    Template: "",
    FileName: null
}

const EmailConfig = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [companyInfo, setCompanyInfo] = useState([]);
    const [EmailSettings, setEmailSettings] = useState(EmailSettingsData);
    const [EmailLogo, setEmailLogo] = useState(null);
    const [displayFile, setdisplayFile] = useState("none");

    useEffect(() => {
        //FetchEmailSettings();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const FetchEmailSettings = () => {
        var companyDetails = JSON.parse(localStorage.getItem("CompanyInfo"));
        setCompanyInfo(companyDetails);

        Axiosfetch(baseURL + "GetEmailSettings", "GET", null, getEmailSettingsSuccess, Failure);
    };

    const getEmailSettingsSuccess = (data) => {
        if (data.length > 0) {
            setEmailSettings(data[0]);
        }
    };

    const onTextChange = (e) => {
        setEmailSettings({ ...EmailSettings, [e.target.name]: e.target.value });
    };

    const onNumberChange = (e) => {
        let value = e.target.value;
        if (value !== "" && !isNaN(value)) {
            setEmailSettings({ ...EmailSettings, [e.target.name]: value });
        }
        else {
            setEmailSettings({ ...EmailSettings, [e.target.name]: 0 });
        }
    };

    const SaveEmailSettingsDetails = (emailData) => {
        Axiosfetch(baseURL + "EditEmailSettings", "POST", emailData, emailDataEditSuccess, Failure);
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const emailDataEditSuccess = (data) => {
        Alert.success(data, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });
    };

    const ValidateEmailSettings = (emailsettings) => {
        var errorMsg = "";
        if (emailsettings === null) {
            errorMsg = "Application Error. Please try again"
        }
        else if (emailsettings.SMTP === "") {
            errorMsg = "Enter Valid SMTP Address";
        }
        else if (emailsettings.PORT === "") {
            errorMsg = "Enter Valid PORT Number";
        }
        else if (emailsettings.Login === "") {
            errorMsg = "Enter Valid Login";
        }
        else if (emailsettings.Password === "") {
            errorMsg = "Enter Valid Password";
        }
        else if (emailsettings.From === "") {
            errorMsg = "Enter Valid From Address";
        }
        else if (emailsettings.Subject === "") {
            errorMsg = "Enter Valid Suject";
        }
        else if (emailsettings.Template.trim() === "" || emailsettings.Template.trim() === "<p><br></p>") {
            errorMsg = "Enter Valid Template";
        }

        if (errorMsg !== "") {
            Alert.error(errorMsg, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
            return false;
        }

        return true;
    };

    const OnFileUpload = (e) => {
        var selectedFile = e.target.files[0];
        if (selectedFile.type === "image/jpeg" || selectedFile.type === "image/png" ||
            selectedFile.type === "image/jpg") {
            setEmailLogo(selectedFile);
        }
        else {
            Alert.error("File Type allowed are : PNG , JPG, JPEG", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const GetEmailFile = (Filename) => {
        if (Filename !== null) {
            Axiosfetch(baseURL + "GetEmailFile", "POST", { fileName: Filename }, FileSuccess, Failure);
        }
    };

    const FileSuccess = (data) => {
        if (data.success) {
            setEmailLogo(data.fileData);
            setdisplayFile("block");
        }
    };


    const RemoveEmailLogoFile = () => {
        setEmailLogo(null);
        setEmailSettings({ ...EmailSettings, "FileName": "" });
    };

    const SendTestEmail = () => {
        var EmailData = EmailSettings;
        if (ValidateEmailSettings(EmailData)) {
            var FormattedEmail = FormatEmail(EmailData, "pankajgandhi1010@gmail.com", "1", companyInfo.Name, 100);
            Axiosfetch(baseURL + "SendEmail", "POST", FormattedEmail, emailDataEditSuccess, Failure);
        }
    };
    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show">
                <div className="row" style={{ height: "78vh", overflow: "auto", paddingBottom: "5px", margin: "5px" }}>
                    <div className="col-md-5">
                        <div className="col-md-12 col-12 align-center">
                            <h5 className="align-center" style={{ fontWeight: "500" }}>Email Configure</h5>
                        </div>
                        <div className="row">
                            <div className="col-md-12 col-12">
                                <div className="text-field">
                                    <input placeholder="" name="AccountNumber" value={EmailSettings.From}
                                        onChange={(e) => onTextChange(e)}
                                        type="text"></input>
                                    <span>From Email<span className="mandatoryStar">*</span></span>
                                </div>
                            </div>
                            <div className="col-md-12 col-12 align-center" style={{ paddingTop: "20px", margin: "auto", display: "flex", justifyContent: "center" }}>
                                {(EmailSettings.FileName === null || EmailSettings.FileName === "") ? (<div style={{ width: "100%" }} className="text-field">
                                    <input type="file" onChange={(e) => OnFileUpload(e)}></input>
                                    <span>Email Logo<span className="mandatoryStar">*</span></span>
                                </div>) :
                                    (<div style={{ border: "none", width: "50%", position: "relative" }}>
                                        <div style={{ borderRadius: "30px" }} onClick={() => GetEmailFile(EmailSettings.FileName)} className="cursor" title="Click to see Profile Photo...">
                                            <img width="80" height="80" alt="Logo" src={`${baseURL}EmailLogo/${EmailSettings.FileName}`}></img>
                                        </div>
                                        <span onClick={RemoveEmailLogoFile} style={{ position: "absolute", left: "80%", top: "0", fontSize: "20px", cursor: "pointer" }}><FontAwesomeIcon style={{ paddingRight: "2px" }} icon={faTimes} /></span>
                                    </div>)}
                            </div>
                            <div className="col-md-12 align-right">
                                <button className={`btn btn-Save ${CurrentTheme}Focus`} onClick={() => SaveEmailSettingsDetails(EmailSettings)}>Save</button>
                                <button className={`btn btn-Save ${CurrentTheme}Focus`} onClick={SendTestEmail}>Test Email</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-7">
                        <div className="col-md-12 col-sm-12 col-12 align-center">
                            <h5 className="align-center" style={{ fontWeight: "500" }}>Email Templates</h5>
                        </div>
                        <div className="col-md-12 col-sm-12 col-12">
                            <div className="align-right">
                                <img width="200" height="80" alt="Welcome Icon" src={WelcomeIcon}></img>
                            </div>
                            <h5>
                                Dear Users,
                            </h5>
                            <div>
                                Please find details of your Invoice below :
                            </div>
                            <div style={{
                                margin: "10px", background: "repeating-linear-gradient(45deg,transparent,transparent 10px,#e5f0fa 10px,#e5f0fa 20px)",
                                border: "1px solid #0369cf", borderRadius: "6px",
                                padding: "10px", marginTop: "10px"
                            }}>
                                <div style={{
                                    display: "flex", justifyContent: "space-between",
                                    padding: "5px 10px 0 10px"
                                }}>
                                    <div>
                                        <h6 style={{ textTransform: "uppercase" }}>Invoice# : <b>3_01042021</b></h6>
                                        <h6 style={{ textTransform: "uppercase" }}>Invoice Date : <b>25/10/2021</b></h6>
                                    </div>
                                    <div className="align-center">
                                        <h6 style={{ textTransform: "uppercase" }}><b>Invoice Amount</b></h6>
                                        <h4 style={{ color: "red" }}>5000 /-</h4>
                                    </div>
                                </div>
                                <div className="align-center" style={{ padding: "5px 10px 5px 5px", display: "flex", borderTop: "1px solid #0369cf", justifyContent: "space-between" }}>
                                    <div>
                                        <h6><b>From</b></h6>
                                        <h6 style={{ textTransform: "uppercase" }}><b>MFI Movers Business Park, #118 Singanayakanahalli Yelahanka Hobli Bangalore North, near Navachethana School, Bengaluru, Karnataka 560064</b></h6>
                                    </div>
                                    <div>
                                        <h6><b>To</b></h6>
                                        <h6 style={{ textTransform: "uppercase" }}><b>MFI Movers Business Park, #118 Singanayakanahalli Yelahanka Hobli Bangalore North, near Navachethana School, Bengaluru, Karnataka 560064</b></h6>
                                    </div>
                                </div>
                            </div>
                            <div>
                                Thank you for your business.
                            </div>
                            <div>
                                <h5> Movers Federation of India.</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmailConfig;